export const UPDATE_PACKAGE_PARAM = {
    REQUEST: 'PACKAGE.UPDATE_PACKAGE_PARAMS.REQUEST',
    SUCCESS: 'PACKAGE.UPDATE_PACKAGE_PARAMS.SUCCESS',
    FAILED: 'PACKAGE.UPDATE_PACKAGE_PARAMS.FAILED',
};

export const RESET_ERROR = 'PACKAGE.UPDATE_PACKAGE_PARAM.RESET_ERROR';

export const CLEAR_STATE = 'PACKAGE.UPDATE_PACKAGE_PARAM.CLEAR_STATE';